/**
 * StatusBadge — a reorder-bucket / risk-tier chip. Always combines COLOR + GLYPH + TEXT (never color
 * alone). Thin wrapper over the UI Badge that maps a bucket/tier to its tone + mandated glyph + label.
 */
import { Badge } from "@/ui";
import { useT } from "@/app";
import type { ReorderBucket, RiskTier } from "../types";
import { bucketVisual, tierVisual } from "../lib";

export function BucketBadge({ bucket }: { bucket: ReorderBucket }) {
  const { t } = useT();
  const v = bucketVisual(bucket);
  return (
    <Badge tone={v.tone} glyph={v.glyph}>
      {t(v.labelKey)}
    </Badge>
  );
}

export function TierBadge({ tier }: { tier: RiskTier }) {
  const { t } = useT();
  const v = tierVisual(tier);
  return (
    <Badge tone={v.tone} glyph={v.glyph}>
      {t(v.labelKey)}
    </Badge>
  );
}
